import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './StaticHeader.css';

const StaticHeader: React.FC = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  
  const handleLoginClick = () => {
    if (isAuthenticated) {
      navigate('/reports');
    } else {
      navigate('/login');
    }
  };
  
  return (
    <header className="static-header">
      <div className="static-header-container">
        <div className="logo">
          <Link to="/">{t('app_name')}</Link>
        </div>
        <nav className="nav">
          <ul className="nav-list">
            <li className="nav-item">
              <Link to="/terms">{t('footer.link_terms')}</Link>
            </li>
            <li className="nav-item">
              <Link to="/privacy">{t('footer.link_privacy')}</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact">{t('footer.link_contact')}</Link>
            </li>
            <li className="nav-item">
              <button onClick={handleLoginClick} className="login-button">
                {isAuthenticated ? t('nav.my_reports') : t('static_header.login')}
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default StaticHeader;
